import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PanelProps extends PropsWithChildren {
  className?: string
}

export function Panel({ children, className }: PanelProps) {
  return (
    <div
      className={cn(
        'w-full flex flex-col border border-ring/50 overflow-hidden rounded-lg',
        className
      )}
    >
      {children}
    </div>
  )
}
